import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { TrazadoresTypes } from "../../app/types/genericTables.types";

type UseTrazadoresType = {
  trazadoresList: TrazadoresTypes[];
  get: (id: TrazadoresTypes["id"]) => TrazadoresTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useTrazadores = create<UseTrazadoresType>((set, get) => ({
  loading: false,
  trazadoresList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().trazadoresList.find((trazador) => trazador.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Trazadores";
      const { data: response } = await getData(endpoint);      
      set(() => ({
        trazadoresList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching TrazadoresList:", error);
      set({ loading: false });
    }
  },
}));




